import { ICON__image_solid } from '@/assets/icons_fa';
import { EKeyCode } from '@/enums/e_key_code';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';
import { path_relative_to_absolute } from '@/utils/utils_files_client';
import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { DTO__grid2d_generation } from '@shared/dto/grid2d/DTO__grid2d_generation';
import { DTO__grid2d_cell_generation } from '@shared/dto/grid2d_cell/DTO__grid2d_cell_generation';
import { WATCHER_SHORTCUT__base } from '../shortcuts/_watchers/WATCHER_SHORTCUT__base';
import { FN_GRID2D_GALLERY_GENERATION__set_cell_current } from './FN_GRID2D_GALLERY_GENERATION__set_cell_current';

interface PROPS {
  grid2d: DTO__grid2d_generation;
  cell: DTO__grid2d_cell_generation;
}

export function GRID2D_GALLERY_GENERATION__image_neigbours_row_item({ cell, grid2d }: PROPS) {
  const dispatch = use_dispatch();

  const { global__grid2d_gallery_cell_current } = use_slice_ui(['global__grid2d_gallery_cell_current']);

  assert_instanceof(global__grid2d_gallery_cell_current, DTO__grid2d_cell_generation);

  const is_current_cell = global__grid2d_gallery_cell_current.x == cell.x && global__grid2d_gallery_cell_current.y == cell.y;

  /*
   *
   */
  function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    FN_GRID2D_GALLERY_GENERATION__set_cell_current(grid2d, cell);
  }

  /*
   *
   */
  function render_image() {
    if (cell.image.is_stub()) return <ICON__image_solid className="size-5 text-bar-foreground" />;

    return (
      <img
        draggable={false}
        src={url_absolute}
        alt={`${cell.image.image_size.width}x${cell.image.image_size.height}`}
        role="button"
        className="nodrag size-full max-w-full max-h-full object-contain rounded "
      />
    );
  }

  function render_shortcuts() {
    if (!is_current_cell) return null;

    let out = [];

    assert_instanceof(global__grid2d_gallery_cell_current, DTO__grid2d_cell_generation);

    let chunk = grid2d.get_generation_chunk();

    if (global__grid2d_gallery_cell_current.x > 0)
      out.push(render_shortcut(EKeyCode.ArrowLeft, global__grid2d_gallery_cell_current.x - 1, global__grid2d_gallery_cell_current.y));

    if (global__grid2d_gallery_cell_current.x < chunk.cells_amount__x - 1)
      out.push(render_shortcut(EKeyCode.ArrowRight, global__grid2d_gallery_cell_current.x + 1, global__grid2d_gallery_cell_current.y));

    if (global__grid2d_gallery_cell_current.y > 0)
      out.push(render_shortcut(EKeyCode.ArrowUp, global__grid2d_gallery_cell_current.x, global__grid2d_gallery_cell_current.y - 1));

    if (global__grid2d_gallery_cell_current.y < chunk.cells_amount__y - 1)
      out.push(render_shortcut(EKeyCode.ArrowDown, global__grid2d_gallery_cell_current.x, global__grid2d_gallery_cell_current.y + 1));

    if (!out.is_empty()) out.push(render_shortcut_close());

    return out;
  }

  function render_shortcut_close() {
    return (
      <WATCHER_SHORTCUT__base
        key={`shortcut__change_cell_close`}
        key_codes={[EKeyCode.Escape]}
        on_shortcut_pressed={() => {
          dispatch(LOCAL__ui_set_boolean({ key: 'global__grid2d_show_as_gallery', value: false }));
          return true;
        }}
      />
    );
  }

  function render_shortcut(key_code: EKeyCode, target_x: number, target_y: number) {
    let chunk = grid2d.get_generation_chunk();

    let cell = chunk.get_cell_by_coordinates(target_x, target_y);

    return (
      <WATCHER_SHORTCUT__base
        key={`shortcut__change_cell_${target_x}_${target_y}`}
        key_codes={[key_code]}
        on_shortcut_pressed={() => {
          FN_GRID2D_GALLERY_GENERATION__set_cell_current(grid2d, cell);
          return true;
        }}
      />
    );
  }

  /*
   *
   */

  const url_absolute = path_relative_to_absolute(cell.image.url_relative_latest);

  return (
    <>
      {render_shortcuts()}
      <div
        className={`size-10 flex-center
        bg-bar
        rounded 
        border-2
        ${is_current_cell ? ' border-green-500' : 'border-component-border'} 
        `}
        {...{ onClick }}
      >
        {render_image()}
      </div>
    </>
  );
}
